// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__14Ojh","toggle":"styles_toggle__1N3O-","preview":"styles_preview__3Lnqg"};